import { createSelector } from '@reduxjs/toolkit';

export const wnUserEdtiableOfficeHoursSelector = createSelector(
  [state => state.wnUser.editableOfficeHours],
  officeHours => officeHours,
);
